import Axios from "./axios";

const resource = "articles";

export default {
  get(params = {}) {
		return Axios.get(`${resource}`, params);
	},
	show(id) {
		return Axios.get(`${resource}/${id}`);
	}
}